import SimpleTableCell from '@/components/SimpleTable/SimpleTableCell';
import SimpleTableRow from '@/components/SimpleTable/SimpleTableRow';

const IssueFormHistoryTableColumns = (): JSX.Element => (
  <SimpleTableRow header>
    <SimpleTableCell name="DISPATCH_ISSUE" className="w-md-grow">
      Dispatch Issues
    </SimpleTableCell>
    <SimpleTableCell name="DATE_TIME">Date/Time</SimpleTableCell>
  </SimpleTableRow>
);

export default IssueFormHistoryTableColumns;
